import React from 'react';
import { TextField } from '@mui/material';

function InsertBar({ currentValue, setNewValue, placeholder, disabled = false }) {
    return (
        <div>
            {disabled ? 
            <TextField
                disabled
                variant="outlined"
                value={currentValue}
                onChange={(e) => setNewValue(e.target.value)}
                size="small"
                placeholder={placeholder}
                sx={{ mt: 1, mb: 1, width: '100%' }}
                InputProps={{
                    sx: {
                        fontSize: 13,
                        color: currentValue ? 'black' : 'gray',
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: '#478F96',
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: '#478F96',
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: '#478F96',
                        },
                        padding: 1,
                    },
                }}
                InputLabelProps={{
                    sx: {
                        fontSize: 13,
                        color: 'gray',
                        padding: 1,
                    },
                }}
            />
            :
            <TextField
                variant="outlined"
                value={currentValue}
                onChange={(e) => setNewValue(e.target.value)}
                size="small"
                placeholder={placeholder}
                sx={{ mt: 1, mb: 1, width: '100%' }}
                InputProps={{
                    sx: {
                        fontSize: 13,
                        color: currentValue ? 'black' : 'gray',
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: '#478F96',
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: '#478F96',
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: '#478F96',
                        },
                        padding: 1,
                    },
                }}
                InputLabelProps={{
                    sx: {
                        fontSize: 13,
                        color: 'gray',
                        padding: 1,
                    },
                }}
            />
        }
        </div>
    );
}

export default InsertBar;
